import moment from 'moment'
import React from 'react'
import styled from 'styled-components'

import DatePicker from '../../../../../../../../../../../1stlog-ui/src/components/DatePicker'
import Field, {
  useField,
} from '../../../../../../../../../../../1stlog-ui/src/components/Field'
import TimePicker from '../../../../../../../../../../../1stlog-ui/src/components/TimePicker/TimePickerIso'

const Wrapper = styled.div`
  display: flex;
`

const TimeWrapper = styled.div``

const TimeDisplayPicker = (props) => {
  const {
    isEditAllowed,
    isOtherEditAvailable,
    onOtherEdit,
    name,
    allowDateChange,
    until,
  } = props

  const isChanged = false

  const time = useField(name)

  const otherTime = useField(name === 'until' ? 'from' : 'until')
  const isNextDay =
    name === 'until' &&
    moment(otherTime).startOf('day').isBefore(moment(time).startOf('day'))

  // console.log('timedisplaypicker', { time, otherTime, isNextDay, name })

  return (
    <Wrapper>
      {isEditAllowed ? (
        <div
          style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}
        >
          <Field name={name}>
            {allowDateChange ? (
              <DatePicker timepicker maxDate={until} />
            ) : (
              <TimePicker />
            )}
          </Field>
          {/* {isNextDay && !allowDateChange && (
            <div style={{ whiteSpace: 'nowrap' }}>
              &nbsp;(+1 {i18n.t('day', 'Tag')})
            </div>
          )} */}
        </div>
      ) : (
        <div>
          <div
            className="d-flex nowrap"
            style={{ whiteSpace: 'nowrap', flexWrap: 'nowrap' }}
          >
            <strong>{moment(time).format('HH:mm')}</strong>
            {/* {isNextDay && !allowDateChange && (
              <div>&nbsp;(+1 {i18n.t('day', 'Tag')})</div>
            )} */}
            {/* {isOtherEditAvailable && (
            <Button
              className="ml-1"
              icon="fas fa-pencil"
              sm
              tooltip="Eine andere Zeitoption ermöglicht die Anpassung dieser Zeit. Klicken Sie hier, um zu dieser Zeitoption zu wechseln."
            />
          )} */}
          </div>
        </div>
      )}
    </Wrapper>
  )
}

export default TimeDisplayPicker
